const cluster_id = {
    title: 'クラスタID',
    text:
        'クラスタを識別するID。各バリューチェーン（Development、Manufacturing、Production、Logistics、Service、Others）毎にクラスタが存在する。'
}

const cluster_name = {
    title: 'クラスタ名',
    text:
        'クラスタとは、各バリューチェーンにおいて該当テーマを構成する主要技術分野（共通因子）を中心に集まった技術群のこと。各クラスタは該当バリューチェーンに所属する企業が保有する特許出願の集まりである。\n\nクラスタ名は、クラスタ内のIPCのラベルに基づいて生成AIによる命名が実施されており、クラスタの技術情報の正確な要約を保証するものではありません。'
}

const score_technological_progress = {
    title: 'スコア（技術の進展度）',
    text:
        'クラスタのスコアであり「技術の進展度」と解釈できる値。「技術スコア」とも呼ぶことがある。\nクラスタのスコアは該当クラスタ内の全企業のスコアの合計値により算出され、スコアが高いほどそのクラスタ（技術群）の技術の進展度が高いと解釈する。'
}

const growth_rate_of_score = {
    title: 'スコア成長率',
    text:
        '直近3年間のクラスタのスコアの成長率であり、該当クラスタ（技術群）の近年の技術進展の速さを表す。\n特許の出願年により期間を区切って分析処理を行い、各期間のスコアの成長率の平均値で算出したもの。'
}

const marketability = {
    title: '市場期待値',
    text:
        'クラスタ内の各企業が過去約10年間に受けてきたマイノリティ出資額（ジョイントベンチャー出資含む）を合計することで算出され、「各クラスタ（技術群）に対する市場からの注目度」を表す。'
}

const market_attention = {
    title: '市場期待値成長率',
    text:
        '直近3年間の市場期待値の成長率を表し、該当クラスタ（技術群）への市場からの注目度の増大率を表す。\n投資年を基に期間を区切って集計し、各期間の市場期待値の成長率の平均値で算出したもの。'
}

const marketability_startup = {
    title: 'スタートアップ市場期待値',
    text:
        'クラスタ内の各スタートアップ企業が過去約10年間に受けてきたマイノリティ出資額（ジョイントベンチャー出資含む）を合計することで算出され、「スタートアップが台頭するクラスタ（技術群）に対する市場からの注目度」を表す。'
}

const market_attention_startup = {
    title: 'スタートアップ市場期待値成長率',
    text:
        '直近3年間のスタートアップ市場期待値の成長率を表し、該当クラスタ（技術群）への市場からの注目度の増大率を表す。\n投資年を基に期間を区切って集計し、各期間の市場期待値の成長率の平均値で算出したもの。'
}

const ip_code = {
    title: 'IPCコード',
    text:
        'IPCは、WIPO（世界知的所有権機関）が定めた特許を分類するための国際特許分類で、セクション・クラス・サブクラス・メイングループ・サブグループの階層構造を持つ。'
}

const factor_load_quantity = {
    title: '因子負荷量',
    text: '該当IPCの主要技術分野（共通因子）への影響度を表し、テーマにおけるIPCの重要度とも解釈できる。'
}

const is_important = {
    title: '重要特許',
    text: '同一IPC分類における被引用回数の上位5%の特許と定義される。'
}

const most_frequent_ipc = {
    title: '最頻IPC',
    text:
        '該当クラスタ内の該当企業の特許出願のIPCの中で最も頻度が高いものを表し、該当クラスタにおける該当企業の主要保有技術と捉えられる。'
}

const score_for_cluster_details = {
    title: 'スコア(技術競争力)',
    text:
        '企業のスコアであり「技術競争力」と解釈できる値。「技術スコア」とも呼ぶことがある。\nクラスタ内の全企業のスコアを合計することでクラスタのスコアを算出している。'
}

const important_patents_count = {
    title: '重要特許数',
    text:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許数は、該当クラスタ内に含まれる企業が持つ重要特許の数を表す。'
}

const important_patent_rate = {
    title: '重要特許率',
    text:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許率は、テーマ内の該当クラスタにおいて、企業が持つ重要特許数を全体の重要特許数で割った割合を表す。'
}

const number_of_forward_citations = {
    title: '被引用数',
    text:
        '該当特許出願が、出願人または特許審査官により他の特許文献に引用された回数を表し、引用数が大きいほどその特許出願の客観的な重要度が高いと言える。'
}

const minority_investment_amount = {
    title: 'マイノリティ出資額',
    text: '該当企業が過去約10年間に受けてきたマイノリティ出資（ジョイントベンチャー出資含む）の合計値を表す。'
}

const startup = {
    title: 'スタートアップ',
    text:
        '①、②いずれかに合致する設立15年以内の企業をスタートアップと定義している（「大学・教育機関」は除外）。\n①非上場企業の場合、「総資産100億円以下」かつ「株主資本50億円以下」\n②上場企業の場合、「過去10年以内にIPOをしている」'
}

const main_ipc = {
    title: '筆頭IPC',
    text:
        '該当特許出願に付与されているIPCのうち、その特許出願に最も関連度の高いIPCのこと。Intelligent Business Analyticsでは、筆頭IPCのみを基に各種分析処理を行っている。'
}

const bubble_size = {
    title: 'バブルの大きさ',
    listTitle1: '特許出願数',
    listText1: '特許出願数に比例してバブルの大きさを変化させる。',
    listTitle2: '特許被引用数',
    listText2: '特許被引用数に比例してバブルの大きさを変化させる。',
    listTitle3: '固定値',
    listText3: '全てのバブルを同じ大きさで表示する。'
}

const portfolio_bubble_scale = {
    title: 'バブルサイズ強調度',
    listTitle1: 'バブルサイズ強調度',
    listText1:
        'バブルサイズの差の強さを調整します。左に動かすと小さいバブルがより小さくなり、右に動かすとバブルのサイズが均一に近づきます。'
}

const portfolio_bubble_size_limit = {
    title: 'バブルサイズ基準値',
    listTitle1: 'バブルサイズ基準値',
    listText1:
        'この値以上のデータは最大サイズのバブルとして表示されます。値を小さくすると、小さいデータ間の差が見えやすくなります。'
}

const x_axis = {
    title: 'X軸',
    listTitle1: 'スコア（技術の進展度）',
    listText1:
        'クラスタのスコアであり「技術の進展度」と解釈できる値。「技術スコア」とも呼ぶことがある。\nクラスタのスコアは該当クラスタ内の全企業のスコアの合計値により算出され、スコアが高いほどそのクラスタ（技術群）の技術の進展度が高いと解釈する。',
    listTitle2: 'スコア成長率',
    listText2:
        '直近3年間のクラスタのスコアの成長率であり、該当クラスタ（技術群）の近年の技術進展の速さを表す。\n特許の出願年により期間を区切って分析処理を行い、各期間のスコアの成長率の平均値で算出したもの。'
}

const y_axis = {
    title: 'Y軸',
    listTitle1: '市場期待値',
    listText1:
        'クラスタ内の各企業が過去約10年間に受けてきたマイノリティ出資額（ジョイントベンチャー出資含む）を合計することで算出され、「各クラスタ（技術群）に対する市場からの注目度」を表す。',
    listTitle2: 'スタートアップ市場期待値',
    listText2:
        'クラスタ内の各スタートアップ企業が過去約10年間に受けてきたマイノリティ出資額（ジョイントベンチャー出資含む）を合計することで算出され、「スタートアップが台頭するクラスタ（技術群）に対する市場からの注目度」を表す。',
    listTitle3: '市場期待値成長率',
    listText3:
        '直近3年間の市場期待値の成長率を表し、該当クラスタ（技術群）への市場からの注目度の増大率を表す。\n投資年を基に期間を区切って集計し、各期間の市場期待値の成長率の平均値で算出したもの。',
    listTitle4: 'スタートアップ市場期待値成長率',
    listText4:
        '直近3年間のスタートアップ市場期待値の成長率を表し、該当クラスタ（技術群）への市場からの注目度の増大率を表す。\n投資年を基に期間を区切って集計し、各期間の市場期待値の成長率の平均値で算出したもの。',
    listTitle5: 'ビジネス規模',
    listText5:
        'クラスタ内の企業の直近年度の売上の合計値であり、該当クラスタの技術を保有する企業の総ビジネス規模を示す。'
}

const portfolio_bubble_size = {
    title: 'バブルの大きさ',
    listTitle1: 'スコア（技術競争力）',
    listText1: '企業のスコアであり該当クラスタにおける該当企業の「技術競争力」と解釈できる。',
    listTitle2: '特許出願数',
    listText2: '該当企業の該当クラスタにおける特許出願数に比例してバブルの大きさを変化させる。',
    listTitle3: '被引用数 （平均値）',
    listText3:
        '該当クラスタにおける該当企業の特許出願が、出願人または特許審査官により他の特許文献に引用された回数の平均値を表し、引用数が大きいほどその特許出願の客観的な重要度が高いと言える。',
    listTitle4: '重要特許数',
    listText4:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許数は、該当クラスタ内に含まれる企業が持つ重要特許の数を表す。',
    listTitle5: '重要特許率',
    listText5:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許率は、テーマ内の該当クラスタにおいて、企業が持つ重要特許数を全体の重要特許数で割った割合を表す。'
}

const portfolio_bubble_size_country = {
    title: 'バブルの大きさ',
    listTitle1: 'スコア（技術競争力）',
    listText1:
        '国のスコアであり「技術競争力」と解釈できる値。「技術スコア」とも呼ぶことがある。クラスタ内の該当国に所属する全企業のスコアを合計することで国のスコアを算出している。',
    listTitle2: 'スコア（平均値）',
    listText2: 'クラスタ内の該当国に所属する全企業のスコアの合計を、企業数で割った平均値を表す。',
    listTitle3: '特許出願数',
    listText3: '該当国に所属する全企業の該当クラスタにおける保有特許出願数。',
    listTitle4: '被引用数（合計）',
    listText4:
        '該当国に所属する企業の特許出願が、出願人または特許審査官により他の特許文献に引用された回数の合計値を表し、引用数が大きいほどその特許出願の客観的な重要度が高いと言える。',
    listTitle5: '被引用数（特許ベース）',
    listText5: '該当国に所属する企業の被引用数合計を、特許数で割った値。',
    listTitle6: '被引用数（企業ベース）',
    listText6: '該当国に所属する企業の被引用数平均を、企業数で割った値。',
    listTitle7: '被引用数（上位N平均）',
    listText7:
        '該当国に所属する企業を被引用数平均の高い順に並べ、上位N%またはN社の企業のみを対象に算出した平均値。被引用数の低い企業の影響を排除し、上位企業の技術力を比較できる。',
    listTitle8: '重要特許数',
    listText8:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許数は、該当クラスタ内に含まれる該当国に所属する企業が持つ重要特許の数の合計を表す。',
    listTitle9: '重要特許率',
    listText9:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許率は、テーマ内の該当クラスタにおいて、該当国に所属する企業が持つ重要特許数を全体の重要特許数で割った割合を表す。'
}

const portfolio_x_axis = {
    title: 'X軸',
    listTitle1: 'スコア（技術の進展度）',
    listText1:
        'クラスタのスコアであり「技術の進展度」と解釈できる値。「技術スコア」とも呼ぶことがある。\nクラスタのスコアは該当クラスタ内の全企業のスコアの合計値により算出され、スコアが高いほどそのクラスタ（技術群）の技術の進展度が高いと解釈する。'
}

const portfolio_y_axis = {
    title: 'Y軸',
    listTitle1: '市場期待値',
    listText1:
        'クラスタ内の各企業が過去約10年間に受けてきたマイノリティ出資額（ジョイントベンチャー出資含む）を合計することで算出され、「各クラスタ（技術群）に対する市場からの注目度」を表す。'
}

const portfolio_x_axis_country = {
    title: 'X軸',
    listTitle1: 'スコア（技術の進展度）',
    listText1:
        'クラスタのスコアであり「技術の進展度」と解釈できる値。「技術スコア」とも呼ぶことがある。\nクラスタのスコアは該当クラスタ内の全企業のスコアの合計値により算出され、スコアが高いほどそのクラスタ（技術群）の技術の進展度が高いと解釈する。'
}

const portfolio_y_axis_country = {
    title: 'Y軸',
    listTitle1: '市場期待値',
    listText1:
        'クラスタ内の各企業が過去約10年間に受けてきたマイノリティ出資額（ジョイントベンチャー出資含む）を合計することで算出され、「各クラスタ（技術群）に対する市場からの注目度」を表す。'
}

const indicative_data = {
    title: '表示データ',
    listTitle1: 'スコア',
    listText1:
        '企業のスコアであり「技術競争力」と解釈できる値。「技術スコア」とも呼ぶことがある。\nクラスタ内の全企業のスコアを合計することでクラスタのスコアを算出している。',
    listTitle2: '特許出願数',
    listText2: '企業の該当クラスタにおける保有特許出願数。',
    listTitle3: '被引用数 （平均値）',
    listText3:
        '該当クラスタにおける該当企業の特許出願が、出願人または特許審査官により他の特許文献に引用された回数の平均値を表し、引用数が大きいほどその特許出願の客観的な重要度が高いと言える。',
    listTitle4: '重要特許数',
    listText4:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許数は、該当クラスタ内に含まれる企業が持つ重要特許の数を表す。',
    listTitle5: '重要特許率',
    listText5:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許率は、テーマ内の該当クラスタにおいて、企業が持つ重要特許数を全体の重要特許数で割った割合を表す。'
}

const indicative_data_country = {
    title: '表示データ',
    listTitle1: 'スコア',
    listText1:
        '国のスコアであり「技術競争力」と解釈できる値。「技術スコア」とも呼ぶことがある。\nクラスタ内の該当国に所属する全企業のスコアを合計することで国のスコアを算出している。',
    listTitle2: 'スコア（平均値）',
    listText2: 'クラスタ内の該当国に所属する全企業のスコアの合計を、企業数で割った平均値を表す。',
    listTitle3: '特許出願数',
    listText3: '該当国に所属する企業の該当クラスタにおける保有特許出願数の合計。',
    listTitle4: '被引用数（合計）',
    listText4: '該当クラスタにおける該当国に所属する全企業の被引用数の総和。規模の大きさを把握するのに適している。',
    listTitle5: '被引用数（特許ベース）',
    listText5: '該当国に所属する企業の被引用数合計を、特許数で割った値。',
    listTitle6: '被引用数（企業ベース）',
    listText6: '該当国に所属する企業の被引用数平均を、企業数で割った値。',
    listTitle7: '被引用数（上位N平均）',
    listText7:
        '該当国に所属する企業を被引用数平均の高い順に並べ、上位N%またはN社の企業のみを対象に算出した平均値。被引用数の低い企業の影響を排除し、上位企業の技術力を比較できる。',
    listTitle8: '重要特許数',
    listText8:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許数は、該当クラスタ内に含まれる該当国に所属する企業が持つ重要特許の数の合計を表す。',
    listTitle9: '重要特許率',
    listText9:
        '重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n重要特許率は、テーマ内の該当クラスタにおいて、該当国に所属する企業が持つ重要特許数を全体の重要特許数で割った割合を表す。'
}

const cluster_highlight = {
    title: 'クラスタをハイライト',
    text: '指定した企業の特許が含まれるクラスタをハイライトする'
}

const company_csv = {
    title: '企業一覧CSV作成',
    text:
        '指定されたクラスタIDに含まれる企業または指定された領域内のクラスタに\n含まれる企業の情報をCSV形式でダウンロードする'
}

const choose_theme = {
    title: 'テーマを選択',
    text:
        'Intelligent Business Analyticsでは、ビジネスや技術の観点から対象とする分析範囲を定めテーマを設定している。\n各テーマについて、IPCやキーワードの組合せで事前定義された特許検索式を用いてダウンロードおよび処理されたデータを収録済であるため、テーマを選択するだけで関連する技術動向を分析できる。'
}

const themes_which_the_company_belongs_to = {
    title: '企業が所属するテーマ',
    text: '選択した企業の特許出願が含まれるテーマを一覧化している'
}

const company_patent_count = {
    title: '指定企業の特許出願件数',
    text: '該当テーマに含まれる選択企業の特許出願件数'
}

const company_granted_count = {
    title: '指定企業の登録特許件数',
    text: '該当テーマに含まれる選択企業の特許出願件数のうち、登録済の特許件数'
}

const company_important_count = {
    title: '指定企業の重要特許件数',
    text: `重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n指定企業の重要特許件数は、企業がテーマ内に持つ重要特許の数を表す。`
}

const company_important_ratio = {
    title: '指定企業の重要特許保有割合',
    text: `重要特許は、同一IPC分類における被引用回数の上位5%の特許と定義される。\n指定企業の重要特許保有割合は、企業がテーマ内に持つ重要特許数をテーマ内に含まれる全体の重要特許件数で割った割合を表す。`
}

const company_citation_count = {
    title: '指定企業の被引用数',
    text: `該当テーマにおける選択した企業の特許出願の被引用数の合計。\n被引用数とは、該当特許出願が、出願人または特許審査官により他の特許文献に引用された回数を表し、引用数が大きいほどその特許出願の客観的な重要度が高いと言える。`
}
const company_patent_ratio = {
    title: '指定企業の特許出願保有割合',
    text: '該当テーマにおける全特許出願のうち、選択企業の特許出願が占める割合'
}

const change_cross_vc = {
    title: 'バリューチェーン横断に切替',
    text: 'IBA分析をバリューチェーンごとではなく、バリューチェーンを横断して実施した結果のデータに変更する。'
}

const search_conditions_of_theme_list = {
    text:
        '複数の検索対象を同時に選択可能であり、いずれかの条件を満たす結果を表示する。\nキーワードと検索オプションの技術分類（IPC）コードは両方の条件を満たす結果を表示する。\nただし、「公開番号/特許番号」を選択した場合、他の検索対象のチェックボックスは自動的に外れ、検索オプションの入力欄も使用不可となる。'
}

const cluster_count = {
    title: 'クラスタ名該当件数',
    text: 'テーマに属するクラスタのなかで検索条件に該当したクラスタの件数'
}

const ipc_label_count = {
    title: '技術分類（IPC）ラベル該当件数',
    text: 'テーマに属するクラスタのなかで検索条件に該当した技術分類（IPC）ラベルの件数'
}

const ipc_code_count = {
    title: '技術分類（IPC）コード該当件数',
    text: 'テーマに属するクラスタのなかで検索条件に該当した技術分類（IPC）コードの件数'
}

const patent_count = {
    title: '特許出願該当件数',
    text: 'テーマに属するクラスタのなかで検索条件に該当した特許出願の件数'
}

const search_conditions_of_cluster_list = {
    text:
        '複数の検索対象を同時に選択可能であり、いずれかの条件を満たす結果を表示する。\nキーワードと検索オプションの技術分類（IPC）コードは両方の条件を満たす結果を表示する。\nただし、「公開番号/特許番号」を選択した場合、他の検索対象のチェックボックスは自動的に外れ、検索オプションの入力欄も使用不可となる。\n発明の名称は選択言語を問わず英語で検索する。'
}

const theme_trends_bubble_size = {
    title: 'バブルの大きさ',
    listTitle1: '特許出願数',
    listText1: '特許出願数に比例してバブルの大きさを変化させる。'
}

const theme_trends_x_axis = {
    title: 'X軸',
    listTitle1: '特許出願数成長率',
    listText1:
        '特許出願数成長率とは、各年度までの累計出願数から年度ごとの成長率を算出し、それらの平均値を示した値。\nIBAに登録されている直近の特許の出願年を最新年とし、最新年に対して6年前から1年前の特許を評価対象としている。'
}

const theme_trends_y_axis = {
    title: 'Y軸',
    listTitle1: '投資成長率',
    listText1:
        '投資成長率とは、各年度までの累積投資総額から計算された、1年あたりの平均成長率を示す値。\nIBAに登録されている直近の特許の出願年を最新年とし、最新年に対して6年前から1年前の特許出願を評価対象としている。',
    listTitle2: '投資総額',
    listText2:
        '投資総額とは、テーマ内の各企業が過去約10年間に受けてきたマイノリティ出資額（ジョイントベンチャー出資含む）の合計額。これは「各テーマに対する市場からの注目度」を表す。',
    listTitle3: 'ビジネス規模',
    listText3: 'ビジネス規模とは、テーマ内の各企業の売上高を合算した値。'
}

const patent_applications = {
    title: '特許出願数',
    text: '企業の該当クラスタにおける保有特許出願数。'
}

const growth_rate_patent_application = {
    title: '特許出願数成長率',
    text:
        '各年度までの累計出願数から年度ごとの成長率を算出し、それらの平均値を示した値。\nIBAに登録されている直近の特許の出願年を最新年とし、最新年に対して6年前から1年前の特許出願を評価対象としている。'
}

const total_investment_amount = {
    title: '投資総額',
    text:
        'テーマ内の各企業が過去約10年間に受けてきたマイノリティ出資額（ジョイントベンチャー出資含む）を合計した値。「各テーマに対する市場からの注目度」を表す。'
}

const investment_growth_rate = {
    title: '投資成長率',
    text:
        '各年度までの累計投資総額から年度ごとの成長率を算出し、それらの平均値を示した値。\nIBAに登録されている直近の特許の出願年を最新年とし、最新年に対して6年前から1年前の特許出願を評価対象としている。'
}

const business_scale = {
    title: 'ビジネス規模',
    text: 'テーマ内の各企業の売上高を合算した値。'
}

const show_actual = {
    title: '軸に実数値を併記',
    text: 'デフォルトでは軸に偏差値が表示されている。この機能をONにすると実数値を併記する。'
}

export const tooltip = {
    link: '詳しい用語説明をみる',
    cluster_id,
    cluster_name,
    score_technological_progress,
    growth_rate_of_score,
    marketability,
    market_attention,
    marketability_startup,
    market_attention_startup,
    ip_code,
    factor_load_quantity,
    is_important,
    most_frequent_ipc,
    score_for_cluster_details,
    important_patents_count,
    important_patent_rate,
    number_of_forward_citations,
    minority_investment_amount,
    startup,
    main_ipc,
    bubble_size,
    x_axis,
    y_axis,
    portfolio_bubble_size,
    portfolio_bubble_size_country,
    portfolio_bubble_scale,
    portfolio_bubble_size_limit,
    portfolio_x_axis,
    portfolio_y_axis,
    portfolio_x_axis_country,
    portfolio_y_axis_country,
    indicative_data,
    indicative_data_country,
    cluster_highlight,
    company_csv,
    choose_theme,
    themes_which_the_company_belongs_to,
    company_patent_count,
    company_granted_count,
    company_important_count,
    company_important_ratio,
    company_citation_count,
    company_patent_ratio,
    change_cross_vc,
    search_conditions_of_theme_list,
    cluster_count,
    ipc_label_count,
    ipc_code_count,
    patent_count,
    search_conditions_of_cluster_list,
    theme_trends_bubble_size,
    theme_trends_x_axis,
    theme_trends_y_axis,
    patent_applications,
    growth_rate_patent_application,
    total_investment_amount,
    investment_growth_rate,
    business_scale,
    show_actual
}
